module.exports = {
  env: process.env.PERSONAL_ENV || 'dev'
};



// WEBPACK FOOTER //
// ./config/env.js